import { Form } from "antd";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { modalActives } from "../../../../redux/slices/simulation/simulationAction";
import { modalsTypeSimulation } from "../../../../types/initStore/initSimulation";
import { useColumnsProviderSimulation } from "../hooks/useColumnsProviderSimulation";
import { TableGeneral } from "../../../../components/table/TableGeneral";
import { truncateFloat } from "../../../../helpers/generalHelper";
import { GetSimulationContext } from "../hooks/useSimulation";
import EquivalencyTable from "./EquivalencyTable";



const ProviderTable = ({ isLoading, providerEquivalency, providerList = [] }) => {
    const dispatch = useDispatch();
    const [providers, setProviders] = useState([]);
    const { updateProject } = GetSimulationContext();
    const [equivalency, setEquivalency] = useState([]);

    const { columns: columnsProvider, props: propsProvider, formProvider } = useColumnsProviderSimulation(dispatch, updateProject);

    useEffect(() => {
        const { hourDLL, hourMX } = providerEquivalency;

        setProviders(
            providerList.map((provider, index) => {
                if (provider.type !== "A") return null;
                const { projectId, name, areaUserId, price = 0, currency, link, status, type, areaName } = provider;
                const equivalencyHrs = currency === "MXN" ? hourMX.$numberDecimal : hourDLL.$numberDecimal;

                return {
                    indexData: index,
                    key: provider._id,
                    _id: provider._id,
                    equivalencyHrs: truncateFloat(price / equivalencyHrs),

                    projectId,
                    name,
                    areaUserId,
                    price,
                    currency,
                    link,
                    status,
                    type,
                    area: areaName,
                };
            })
                .filter((provider) => provider !== null)
        );
    }, [providerEquivalency, providerList]);

    useEffect(() => {
        if (!providerEquivalency) return;
        setEquivalency([
            {
                key: "assetMoneyMX",
                name: "MX",
                hrs: providerEquivalency.hourMX.$numberDecimal,
            },
            {
                key: "assetMoneyDLL",
                name: "Dll",
                hrs: providerEquivalency.hourDLL.$numberDecimal,
            },
        ]);
    }, [providerEquivalency]);

    return (
        <div className="w-full flex flex-col md:flex-row gap-4 md:pr-4 mt-4">
            <EquivalencyTable
                title="Proveedores"
                action={() => {
                    dispatch(modalActives(modalsTypeSimulation.provider, true));
                }}
                isLoading={isLoading}
                state={equivalency}
            />

            <div className="md:w-4/5">
                <div className="h-5 flex items-center mb-6 md:-mt-6 -mt-0">
                    <h3 className="text-[#282828] text-xs font-bold">Tabla general de provedores</h3>
                </div>
                <Form form={formProvider} component={false}>
                    <TableGeneral
                        loading={isLoading}
                        state={providers}
                        column={columnsProvider}
                        tableProps={propsProvider}
                        pagination={{ position: ["bottomRight", "bottomRight"], pageSize: 5 }}
                    />
                </Form>
            </div>
        </div>
    );
};

export default ProviderTable;
